import { memo } from 'react'
import styled from 'styled-components'

import { CssUnit } from '@/types'

const Wrapper = styled.div<{
  gutter: CssUnit
  col: number
  bottom?: CssUnit
  inline?: boolean
  justify?: boolean
}>`
  position: relative;
  width: 100%;
  padding-right: ${props => props.gutter}px;
  padding-left: ${props => props.gutter}px;
  flex: 0 0 ${props => (props.col * 100) / 12}%;
  max-width: ${props => (props.col * 100) / 12}%;
  margin-bottom: ${props => (props.bottom ? `${props.bottom}px` : '1rem')};

  input {
    display: block;
  }

  ${props =>
    props.inline &&
    `
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    label {
      margin-bottom: 0;
      margin-right: 2rem;
    }
  `}

  ${props =>
    props.justify &&
    `
    justify-content: ${props.justify};
  `}
`
interface Props {
  children: React.ReactNode
  col?: number
  gutter?: CssUnit
  bottom?: CssUnit
  inline?: boolean
  justify?: boolean
}

const Group: React.FC<Props> = ({
  children,
  col = 12,
  gutter = 10,
  ...rest
}) => (
  <Wrapper {...rest} col={col} gutter={gutter}>
    {children}
  </Wrapper>
)

export default memo(Group)
